import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { RyderOrderHistory } from "./ryderOrderHistory";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string, boolean } from "yup";
import { toast } from "react-toastify";
import NoImageFound from "../../assets/images/No-Image-found.png";

const validationSchema = object().shape({
  first_name: string().required("First Name is required"),
  door_no: string().required("Door No is required"),
  street: string().required("Street is required"),
  area: string().required("Area is required"),
  city: string().required("City is required"),
  state: string().required("State is required"),
  pincode: string().required("Pincode is required"),
  // bank_name: string().required("Bank Name is required"),
  // bank_account_number: string().required("Bank Account Number is required"),
  // razorpay_account_id: string().required("razorpay account id is required"),
  // ifsc_code: string().required("ifsc code is required"),
  vehicle_type: string().required("vehicle type is required"),
  // aadhaar_number: string().required("aadhaar Number is required"),
  driving_licence_number: string().required(
    "driving licence Number is required",
  ),
  // beneficiary_name: string().required("beneficiary name is required"),

  bank_name: string(),
  bank_account_number: string(),
  ifsc_code: string(),
  beneficiary_name: string(),

  bank_validated: boolean().test(
    "bank-validated-required",
    "Please validate bank details before submitting",
    function (value) {
      const { bank_name, bank_account_number, ifsc_code, beneficiary_name } =
        this.parent;

      const hasBankDetails =
        bank_name || bank_account_number || ifsc_code || beneficiary_name;

      // If no bank details - allow submit
      if (!hasBankDetails) return true;

      //  Bank details present - must be validated
      return value === true;
    },
  ),
});

export const EditRyderPersonalDetailes = ({ id }) => {
  const [loading, setLoading] = useState(false);
  const [docMap, setDocMap] = useState({});
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  // const [imageUrl, setImageUrl] = useState("");
  const [previewFile, setPreviewFile] = useState({
    url: "",
    type: "", // "image" | "pdf" | "unsupported"
  });

  const [ryder, setRyder] = useState(null);
  const [toggleModalOpenVerification, setToggleModalOpenVerification] =
    useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);
  // reupload
  const [reuploadMode, setReuploadMode] = useState({});
  const [profilePicture, setProfilePicture] = useState("");

  const navigate = useNavigate();

  console.log(id);

  const VERIFIED_FIELD_MAP = {
    // profile_picture: "profile_verified",
    aadhaar_card: "aadhaar_card_verified",
    pan_card: "pan_card_verified",
    // driving_licence: "driving_license_verified",
    driving_license: "driving_license_verified",
  };

  const renameFile = (file, username, key) => {
    const ext = file.name.split(".").pop();
    const newName = `${username}_${key}.${ext}`;
    return new File([file], newName, { type: file.type });
  };

  const formik = useFormik({
    initialValues: {
      // Personal details
      first_name: "",
      last_name: "",
      email: "",
      door_no: "",
      street: "",
      area: "",
      city: "",
      state: "",
      pincode: "",

      // Bank details
      bank_name: "",
      bank_account_number: "",
      ifsc_code: "",
      beneficiary_name: "",

      // Identification details
      pan_number: "",
      aadhaar_number: "",
      driving_licence_number: "",
      vehicle_type: "",

      // Razorpay
      razorpay_account_id: "",

      // Verification checkboxes
      profile_verified: false,
      aadhaar_card_verified: false,
      pan_card_verified: false,
      driving_license_verified: false,

      // Ryder account status
      is_registered: false,
      is_verified: false,
      is_active: false,
      bank_validated: false,

      // ***** FILE UPLOAD FIELDS (MUST HAVE!) *****
      profile_picture_file: null,
      aadhaar_card_file: null,
      pan_card_file: null,
      // driving_licence_file: null,
      driving_license_file: null,
    },
    validationSchema,

    onSubmit: async (values) => {
      setLoading(true);
      //  BLOCK IF DRIVING LICENSE EXISTS BUT NOT VERIFIED
      // if (
      //   docMap?.driving_license?.file_path &&
      //   !values.driving_license_verified
      // ) {
      //   formik.setFieldError(
      //     "driving_license_verified",
      //     "Please verify the driving license before submitting"
      //   );

      //   formik.setFieldTouched("driving_license_verified", true, false);

      //   setLoading(false);
      //   return;
      // }

      // BLOCK IF DRIVING LICENCE AND IS_VERIFIED NOT EXIT
      const hasExistingDrivingLicenseImage = Boolean(
        docMap?.driving_license?.file_path,
      );

      const hasNewDrivingLicenseImage = Boolean(values.driving_license_file);
      // business outlet image
      if (!hasExistingDrivingLicenseImage && !hasNewDrivingLicenseImage) {
        formik.setFieldError(
          "driving_license_file",
          "Driving license image is required",
        );

        formik.setFieldTouched("driving_license_file", true, false);

        setLoading(false);
        return;
      }
      // is verfied
      if (
        (hasExistingDrivingLicenseImage || hasNewDrivingLicenseImage) &&
        !values.driving_license_verified
      ) {
        formik.setFieldError(
          "driving_license_verified",
          "Please verify the driving license image before submitting",
        );

        formik.setFieldTouched("driving_license_verified", true, false);

        setLoading(false);
        return;
      }

      try {
        const docKeys = [
          // "profile_picture",
          "aadhaar_card",
          "pan_card",
          // "driving_licence",
          "driving_license",
        ];

        // const uploadedDocs = docKeys.filter((key) => values[`${key}_file`]);
        // const hasFileUpload = uploadedDocs.length > 0;

        // changed here for  profile picture upload outside
        const uploadedDocs = docKeys.filter((key) => values[`${key}_file`]);

        const hasBusinessDocUpload = uploadedDocs.length > 0;
        const hasProfileUpload = Boolean(values.profile_picture_file);

        const hasFileUpload = hasBusinessDocUpload || hasProfileUpload;

        /**
         * =====================================================
         * CASE 1 — NO FILE UPLOAD → NORMAL PUT JSON
         * =====================================================
         */
        if (!hasFileUpload) {
          const businessDocsPayload = docKeys
            .filter((key) => docMap[key]?.businessdoc_id)
            .map((key) => ({
              businessdoc_id: docMap[key].businessdoc_id,
              //   is_verified:
              //     values[
              //       key === "profile_picture"
              //         ? "profile_verified"
              //         : key === "aadhaar_card"
              //         ? "aadhaar_card_verified"
              //         : key === "pan_card"
              //         ? "pan_card_verified"
              //         : "driving_license_verified"
              //     ],
              // }));
              is_verified:
                key === "aadhaar_card"
                  ? values.aadhaar_card_verified
                  : key === "pan_card"
                    ? values.pan_card_verified
                    : values.driving_license_verified,
            }));

          const jsonPayload = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            door_no: values.door_no,
            street: values.street,
            area: values.area,
            city: values.city,
            state: values.state,
            pincode: values.pincode,
            bank_name: values.bank_name,
            bank_account_number: values.bank_account_number,
            ifsc_code: values.ifsc_code,
            beneficiary_name: values.beneficiary_name,
            pan_number: values.pan_number,
            aadhaar_number: values.aadhaar_number,
            driving_licence_number: values.driving_licence_number,
            razorpay_account_id: values.razorpay_account_id,

            delivery_partner: {
              aadhaar_number: values.aadhaar_number,
              driving_licence_number: values.driving_licence_number,
              vehicle_type: values.vehicle_type,
            },

            is_registered: values.is_registered,
            is_verified: values.is_verified,
            is_active: values.is_active,
            bank_validated: values.bank_validated,

            business_docs: businessDocsPayload,
          };

          const response = await axiosInstance.put(
            `/admin/ryder-list/${id}/`,
            jsonPayload,
          );

          if (response.data.status === "success") {
            toast.success("Ryder updated successfully!");
            setTimeout(() => navigate("/manage-ryder"), 1500);
          }

          return;
        }

        /**
         * =====================================================
         * CASE 2 — SEQUENTIAL FILE UPLOAD (ONE BY ONE)
         * =====================================================
         */
        for (let i = 0; i < uploadedDocs.length; i++) {
          const key = uploadedDocs[i];
          const existingDoc = docMap[key];
          const originalFile = values[`${key}_file`];

          // 🔹 Rename file
          const renamedFile = renameFile(
            originalFile,
            values.username || ryder?.username,
            key,
          );

          const formData = new FormData();

          if (existingDoc?.businessdoc_id) {
            formData.append(
              "business_docs[0][businessdoc_id]",
              existingDoc.businessdoc_id,
            );
          }

          formData.append("business_docs[0][file_name]", key);
          formData.append("business_docs[0][file_path]", renamedFile);

          const patchResponse = await axiosInstance.patch(
            `/admin/ryder-list/${id}/`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          );

          if (patchResponse.data.status !== "success") {
            toast.error(`Failed to upload ${key}`);
            return;
          }
        }
        /*
         * =====================================================
         *  special case for profile upload
         * =====================================================
         */

        if (values.profile_picture_file) {
          const profileFormData = new FormData();
          profileFormData.append(
            "profile_picture",
            renameFile(
              values.profile_picture_file,
              values.username || ryder?.username,
              "profile_picture",
            ),
          );

          const profileRes = await axiosInstance.patch(
            `/admin/ryder-list/${id}/`,
            profileFormData,
            { headers: { "Content-Type": "multipart/form-data" } },
          );

          if (profileRes.data.status !== "success") {
            toast.error("Failed to upload profile picture");
            return;
          }
        }

        /**
         * =====================================================
         * CASE 3 — FINAL PUT JSON (AFTER FILE UPLOADS)
         * =====================================================
         */
        // const filteredDocs = docKeys
        //   .filter((key) => docMap[key]?.businessdoc_id)
        //   .map((key) => ({
        //     businessdoc_id: docMap[key].businessdoc_id,
        //     is_verified:
        //       values[
        //         key === "profile_picture"
        //           ? "profile_verified"
        //           : key === "aadhaar_card"
        //           ? "aadhaar_card_verified"
        //           : key === "pan_card"
        //           ? "pan_card_verified"
        //           : "driving_license_verified"
        //       ],
        //   }));
        const filteredDocs = docKeys
          .filter((key) => docMap[key]?.businessdoc_id)
          .map((key) => ({
            businessdoc_id: docMap[key].businessdoc_id,
            is_verified:
              key === "aadhaar_card"
                ? values.aadhaar_card_verified
                : key === "pan_card"
                  ? values.pan_card_verified
                  : values.driving_license_verified,
          }));

        const finalPayload = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          door_no: values.door_no,
          street: values.street,
          area: values.area,
          city: values.city,
          state: values.state,
          pincode: values.pincode,
          bank_name: values.bank_name,
          bank_account_number: values.bank_account_number,
          ifsc_code: values.ifsc_code,
          beneficiary_name: values.beneficiary_name,
          pan_number: values.pan_number,
          aadhaar_number: values.aadhaar_number,
          driving_licence_number: values.driving_licence_number,
          vehicle_type: values.vehicle_type,
          razorpay_account_id: values.razorpay_account_id,

          delivery_partner: {
            aadhaar_number: values.aadhaar_number,
            driving_licence_number: values.driving_licence_number,
          },

          is_registered: values.is_registered,
          is_verified: values.is_verified,
          is_active: values.is_active,
          bank_validated: values.bank_validated,

          business_docs: filteredDocs,
        };

        const putResponse = await axiosInstance.put(
          `/admin/ryder-list/${id}/`,
          finalPayload,
        );

        if (putResponse.data.status === "success") {
          toast.success("Ryder updated successfully!");
          setTimeout(() => navigate("/manage-ryder"), 1500);
        }
      } catch (err) {
        console.error("ERR:", err);
        toast.error("Something went wrong.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate("/manage-ryder");
  };

  // useEffect(() => {
  //   const fetchRyderDetails = async () => {
  //     try {
  //       const res = await axiosInstance.get(`/admin/ryder-list/${id}`);
  //       if (res.data.status === "success" && res.data.data) {
  //         const data = res.data.data;

  //         // Create a map of document name → document object
  //         const docs = data.business_docs || [];
  //         const docObject = {};
  //         docs.forEach((doc) => {
  //           docObject[doc.file_name] = doc;
  //         });
  //         setDocMap(docObject); // ⬅️ Store for preview/buttons etc.

  //         // Set Formik values
  //         formik.setValues({
  //           ...formik.values,
  //           first_name: data.first_name || "",
  //           last_name: data.last_name || "",
  //           email: data.email || "",
  //           mobile_no: data.mobile_no || "",
  //           door_no: data.door_no || "",
  //           street: data.street || "",
  //           area: data.area || "",
  //           city: data.city || "",
  //           state: data.state || "",
  //           pincode: data.pincode || "",
  //           vehicle_type: data.delivery_partner.vehicle_type || "",
  //           business_name: data.wholesalers?.business_name || "",
  //           bank_name: data.bank_name || "",
  //           ifsc_code: data.ifsc_code || "",
  //           beneficiary_name: data.beneficiary_name || "",
  //           bank_account_number: data.bank_account_number || "",
  //           razorpay_account_id: data.razorpay_account_id || "",
  //           pan_number: data.pan_number || "",
  //           profile_picture: data.profile_picture || "",
  //           aadhaar_number: data.delivery_partner.aadhaar_number || "",
  //           driving_licence_number:
  //             data.delivery_partner.driving_licence_number || "",

  //           // 🆕 Set verification flags from document map
  //           profile_verified: docObject["profile"]?.is_verified || false,
  //           aadhaar_card_verified:
  //             docObject["aadhaar_card"]?.is_verified || false,
  //           driving_license_verified:
  //             docObject["driving_license"]?.is_verified || false,
  //           pan_card_verified: docObject["pan_card"]?.is_verified || false,
  //           is_registered: data.is_registered,
  //           is_verified: data.is_verified,
  //           is_active: data.is_active,
  //         });
  //       } else {
  //         toast.error("Failed to load ryder details.");
  //         setDocMap({});
  //       }
  //     } catch (err) {
  //       console.error("Error fetching ryder data:", err);
  //       toast.error("Something went wrong while loading wholesaler data.");
  //       setDocMap({});
  //     }
  //   };

  //   fetchRyderDetails();
  // }, [id]);

  useEffect(() => {
    const fetchRyderDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/ryder-list/${id}`);

        if (res.data.status === "success" && res.data.data) {
          const data = res.data.data;
          setRyder(data);
          // Set profile picture separately
          setProfilePicture(data.profile_picture || "");

          const docs = data.business_docs || [];
          const docObject = {};
          const verifiedValues = {};

          docs.forEach((doc) => {
            docObject[doc.file_name] = doc;

            const verifiedKey = VERIFIED_FIELD_MAP[doc.file_name];
            if (verifiedKey) {
              verifiedValues[verifiedKey] = Boolean(doc.is_verified);
            }
          });

          // docs.forEach((doc) => {
          //   // normalize both spellings to ONE key
          //   const normalizedKey =
          //     doc.file_name === "driving_licence"
          //       ? "driving_license"
          //       : doc.file_name;

          //   docObject[normalizedKey] = doc;

          //   const verifiedKey = VERIFIED_FIELD_MAP[normalizedKey];
          //   if (verifiedKey) {
          //     verifiedValues[verifiedKey] = Boolean(doc.is_verified);
          //   }
          // });

          setDocMap(docObject);

          formik.setValues((prev) => ({
            ...prev,

            // Personal
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            email: data.email || "",
            door_no: data.door_no || "",
            street: data.street || "",
            area: data.area || "",
            city: data.city || "",
            state: data.state || "",
            pincode: data.pincode || "",
            pan_number: data.pan_number || "",
            mobile_no: data.mobile_no || "",

            // Bank
            bank_name: data.bank_name || "",
            bank_account_number: data.bank_account_number || "",
            ifsc_code: data.ifsc_code || "",
            beneficiary_name: data.beneficiary_name || "",
            razorpay_account_id: data.razorpay_account_id || "",

            // Delivery partner
            aadhaar_number: data.delivery_partner?.aadhaar_number || "",
            driving_licence_number:
              data.delivery_partner?.driving_licence_number || "",
            vehicle_type: data.delivery_partner?.vehicle_type || "",

            // Status
            is_registered: Boolean(data.is_registered),
            is_verified: Boolean(data.is_verified),
            is_active: Boolean(data.is_active),
            bank_validated: data.bank_validated,

            // ✅ VERIFIED CHECKBOXES (FIXED)
            ...verifiedValues,
          }));
        } else {
          toast.error("Failed to load Ryder details");
          setDocMap({});
        }
      } catch (err) {
        console.error("Error fetching Ryder:", err);
        toast.error("Something went wrong while loading Ryder data");
        setDocMap({});
      }
    };

    fetchRyderDetails();
  }, [id]);

  const handleToggleStatus = () => {
    if (!toggleTarget) return;
    formik.setFieldValue(toggleTarget.field, !toggleTarget.currentValue);
    setToggleModalOpenVerification(false);
    setToggleTarget(null);
  };

  if (loading) return <p>Loading ryder details...</p>;
  // if (ryder) return <p>No ryder data found.</p>;

  const getFileType = (url = "") => {
    const extension = url.split(".").pop()?.toLowerCase();

    if (["jpg", "jpeg", "png", "webp"].includes(extension)) return "image";
    if (extension === "pdf") return "pdf";

    return "unsupported";
  };

  const openPreview = (filePath) => {
    if (!filePath) return;

    setPreviewFile({
      url: filePath,
      type: getFileType(filePath),
    });

    setToggleModalOpen(true);
  };

  return (
    <>
      <div className="editWholesaler-container">
        <form onSubmit={formik.handleSubmit}>
          <div className="editWholesaler-subcontainer">
            <div>
              <span className="edit-title">General Information</span>
            </div>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>First Name
                </label>
                <div>
                  <input
                    type="text"
                    name="first_name"
                    placeholder="Enter Your First Name"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.first_name && formik.errors.first_name && (
                    <div className="text-danger">
                      {formik.errors.first_name}
                    </div>
                  )}
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>Email id</label>
                <div>
                  <input
                    type="text"
                    name="email"
                    placeholder="Enter Your email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>Mobile Number</label>
                <div>
                  <input
                    type="tel"
                    name="mobile_no"
                    placeholder="Enter Your mobile_no"
                    value={formik.values.mobile_no}
                    onBlur={formik.handleBlur}
                    maxLength={10}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <label>Last Name</label>
                <div>
                  <input
                    type="text"
                    name="last_name"
                    placeholder="Enter Your Last Name"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>

              {/* <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>
                    <span className="text-danger">*</span>Selfie
                  </label>

                  {docMap["profile_picture"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["profile_picture"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          profile_picture: !prev["profile_picture"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["profile_picture"]?.file_path &&
                  !reuploadMode["profile_picture"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(
                        //     docMap["profile_picture"].file_path || ""
                        //   );
                        //   setToggleModalOpen(true);
                        // }}
                        onClick={() =>
                          openPreview(docMap["profile_picture"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>
                    </div>
                  ) : (
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue(
                          "profile_picture_file",
                          e.target.files[0]
                        )
                      }
                    />
                  )}
                </div>
              </div> */}
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>
                    <span className="text-danger">*</span>Selfie
                  </label>

                  {profilePicture && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode.profile_picture ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          profile_picture: !prev.profile_picture,
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {profilePicture && !reuploadMode.profile_picture ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        onClick={() => openPreview(profilePicture)}
                      >
                        Preview the document
                      </button>
                    </div>
                  ) : (
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue(
                          "profile_picture_file",
                          e.target.files[0],
                        )
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* address */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Business Address</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Door No/House No
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Door No/House No"
                    name="door_no"
                    value={formik.values.door_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.door_no && formik.errors.door_no && (
                    <div className="text-danger">{formik.errors.door_no}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Area/Locality
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Area"
                    name="area"
                    value={formik.values.area}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.area && formik.errors.area && (
                    <div className="text-danger">{formik.errors.area}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>City/Town
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your City"
                    name="city"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.city && formik.errors.city && (
                    <div className="text-danger">{formik.errors.city}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Street
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Street"
                    name="street"
                    value={formik.values.street}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.street && formik.errors.street && (
                    <div className="text-danger">{formik.errors.street}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>State
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your State"
                    name="state"
                    value={formik.values.state}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.state && formik.errors.state && (
                    <div className="text-danger">{formik.errors.state}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Pincode
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Pincode"
                    name="pincode"
                    value={formik.values.pincode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.pincode && formik.errors.pincode && (
                    <div className="text-danger">{formik.errors.pincode}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Bank Information  */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Bank Information</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Bank Account Number
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Bank Account Number"
                    name="bank_account_number"
                    value={formik.values.bank_account_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.bank_account_number &&
                    formik.errors.bank_account_number && (
                      <div className="text-danger">
                        {formik.errors.bank_account_number}
                      </div>
                    )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Bank Name
                </label>

                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Bank Name"
                    name="bank_name"
                    value={formik.values.bank_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.bank_name && formik.errors.bank_name && (
                    <div className="text-danger">{formik.errors.bank_name}</div>
                  )}
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Aadhaar Number
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your aadhaar number"
                    name="aadhaar_number"
                    value={formik.values.aadhaar_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.aadhaar_number &&
                    formik.errors.aadhaar_number && (
                      <div className="text-danger">
                        {formik.errors.aadhaar_number}
                      </div>
                    )}
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Driving licence Number
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your driving_licence_number"
                    name="driving_licence_number"
                    value={formik.values.driving_licence_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.driving_licence_number &&
                    formik.errors.driving_licence_number && (
                      <div className="text-danger">
                        {formik.errors.driving_licence_number}
                      </div>
                    )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Account Holder Name
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your benefiiary name"
                    name="beneficiary_name"
                    value={formik.values.beneficiary_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.beneficiary_name &&
                    formik.errors.beneficiary_name && (
                      <div className="text-danger">
                        {formik.errors.beneficiary_name}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  IFSC Code
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your ifsc code"
                    name="ifsc_code"
                    value={formik.values.ifsc_code}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.ifsc_code && formik.errors.ifsc_code && (
                    <div className="text-danger">{formik.errors.ifsc_code}</div>
                  )}
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Razorpay Account ID
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your ifsc code"
                    name="razorpay_account_id"
                    value={formik.values.razorpay_account_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.razorpay_account_id &&
                    formik.errors.razorpay_account_id && (
                      <div className="text-danger">
                        {formik.errors.razorpay_account_id}
                      </div>
                    )}
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>Pan Number</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your pan number"
                    name="pan_number"
                    value={formik.values.pan_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>
                  Vehicle Type
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your vehicle_type"
                    name="vehicle_type"
                    value={formik.values.vehicle_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.vehicle_type &&
                    formik.errors.vehicle_type && (
                      <div className="text-danger">
                        {formik.errors.vehicle_type}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>IS Bank Validated</label>
              <div
                className="form-check form-switch"
                style={{ marginTop: "5px" }}
              >
                <input
                  type="checkbox"
                  className="form-check-input form-check-input-verification"
                  checked={formik.values.bank_validated}
                  onChange={() => {
                    setToggleTarget({
                      field: "bank_validated",
                      currentValue: formik.values.bank_validated,
                    });
                    setToggleModalOpenVerification(true);
                  }}
                />
              </div>
              <div>
                {formik.errors.bank_validated && (
                  <div className="text-danger">
                    {formik.errors.bank_validated}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* KYC */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">KYC</span>
          </div>

          <div className="general-container">
            {/* LEFT COLUMN */}
            {/* <div className="general-left">
              {Object.values(docMap)
                .filter((_, idx) => idx % 2 === 0)
                .map((doc) => (
                  <div
                    className="editWholesaler-field"
                    key={doc.businessdoc_id}
                  >
                    <label>
                      {doc.file_name.replace(/_/g, " ").toUpperCase()}
                    </label>
                    <div>
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          onClick={() => {
                            setImageUrl(doc.file_path || "");
                            setToggleModalOpen(true);
                          }}
                          disabled={!doc.file_path}
                        >
                          Preview the document
                        </button>
                      </div>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name={`${doc.file_name}_verified`}
                          checked={
                            formik.values[`${doc.file_name}_verified`] || false
                          }
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>
                    </div>
                  </div>
                ))}
            </div> */}

            <div className="general-left">
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>Aadhaar Card</label>

                  {docMap["aadhaar_card"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["aadhaar_card"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          aadhaar_card: !prev["aadhaar_card"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["aadhaar_card"]?.file_path &&
                  !reuploadMode["aadhaar_card"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(docMap["aadhaar_card"].file_path || "");
                        //   setToggleModalOpen(true);
                        // }}
                        onClick={() =>
                          openPreview(docMap["aadhaar_card"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="aadhaar_card_verified"
                          checked={formik.values.aadhaar_card_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>
                    </div>
                  ) : (
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue(
                          "aadhaar_card_file",
                          e.target.files[0],
                        )
                      }
                    />
                  )}
                </div>
              </div>

              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>PAN Card</label>

                  {docMap["pan_card"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["pan_card"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          pan_card: !prev["pan_card"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["pan_card"]?.file_path &&
                  !reuploadMode["pan_card"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(docMap["pan_card"].file_path || "");
                        //   setToggleModalOpen(true);
                        // }}
                        onClick={() =>
                          openPreview(docMap["pan_card"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="pan_card_verified"
                          checked={formik.values.pan_card_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>
                    </div>
                  ) : (
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue("pan_card_file", e.target.files[0])
                      }
                    />
                  )}
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN */}
            {/* <div className="general-right">
              {Object.values(docMap)
                .filter((_, idx) => idx % 2 !== 0) // odd index → right
                .map((doc) => (
                  <div
                    className="editWholesaler-field"
                    key={doc.businessdoc_id}
                  >
                    <label>
                      {doc.file_name.replace(/_/g, " ").toUpperCase()}
                    </label>
                    <div>
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          onClick={() => {
                            setImageUrl(doc.file_path || "");
                            setToggleModalOpen(true);
                          }}
                          disabled={!doc.file_path}
                        >
                          Preview the document
                        </button>
                      </div>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name={`${doc.file_name}_verified`}
                          checked={
                            formik.values[`${doc.file_name}_verified`] || false
                          }
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>
                    </div>
                  </div>
                ))}
            </div> */}

            <div className="general-right">
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>
                    {" "}
                    <span className="text-danger">*</span>Driving Licence
                  </label>

                  {docMap["driving_license"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["driving_license"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          // driving_licence: !prev["driving_license"],
                          driving_license: !prev.driving_license,
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["driving_license"]?.file_path &&
                  !reuploadMode["driving_license"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(
                        //     docMap["driving_licence"].file_path || ""
                        //   );
                        //   setToggleModalOpen(true);
                        // }}
                        onClick={() =>
                          openPreview(docMap["driving_license"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        onChange={(e) =>
                          formik.setFieldValue(
                            // "driving_licence_file",
                            "driving_license_file",
                            e.target.files[0],
                          )
                        }
                      />
                      {formik.touched.driving_license_file &&
                        formik.errors.driving_license_file && (
                          <div className="text-danger">
                            {formik.errors.driving_license_file}
                          </div>
                        )}
                    </>
                  )}
                </div>
                {/* CHECKBOX FOR BOTH EXISTING AND NEWLY SELECTED IMAGE */}
                <div className="mt-2 ">
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      name="driving_license_verified"
                      checked={formik.values.driving_license_verified}
                      onChange={formik.handleChange}
                    />
                    <span className="textIsverified">Is Verified</span>
                  </div>

                  <div>
                    {(formik.touched.driving_license_verified ||
                      formik.submitCount > 0) &&
                      formik.errors.driving_license_verified && (
                        <div className="text-danger mt-1">
                          {formik.errors.driving_license_verified}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Ryder Verification</span>
          </div>

          <div className="general-container">
            <div className="general-left">
              {/* IS Registered */}
              <div className="editWholesaler-field">
                <label>IS Registered</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_registered}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_registered",
                        currentValue: formik.values.is_registered,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>

              {/* IS Verified */}
              <div className="editWholesaler-field">
                <label>IS Verified</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_verified}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_verified",
                        currentValue: formik.values.is_verified,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="general-right">
              {/* IS Active */}
              <div className="editWholesaler-field">
                <label>IS Active</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_active}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_active",
                        currentValue: formik.values.is_active,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* buttons*/}
          <div className="addbtnContainer">
            <div>
              <button
                type="button"
                className="admin-btnCancel"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
            <div>
              <button className="whole-btnUpdate" disabled={loading}>
                {loading ? "Updateing..." : "Update"}
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* <Modal
        open={toggleModalOpen}
        onClose={() => setToggleModalOpen(false)}
        aria-labelledby="toggle-status-title"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <button
            onClick={() => setToggleModalOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">Preview the document</h3>
          <hr />
          <div style={{ textAlign: "center" }}>
            {imageUrl ? (
              <img
                src={imageUrl || NoImageFound}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            ) : (
              <div>No document to display.</div>
            )}
          </div>
          <hr />
        </Box>
      </Modal> */}

      <Modal
        open={toggleModalOpen}
        onClose={() => setToggleModalOpen(false)}
        aria-labelledby="toggle-status-title"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: 600,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* Close Button */}
          <button
            onClick={() => setToggleModalOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">Preview the document</h3>
          <hr />

          <div style={{ textAlign: "center" }}>
            {/* 🖼 IMAGE PREVIEW */}
            {previewFile.type === "image" && (
              <img
                src={previewFile.url}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "450px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            )}

            {/* 📄 PDF PREVIEW */}
            {previewFile.type === "pdf" && (
              <iframe
                src={previewFile.url}
                title="PDF Preview"
                width="100%"
                height="500px"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            )}

            {/* ❌ UNSUPPORTED */}
            {previewFile.type === "unsupported" && (
              <p style={{ color: "#888" }}>
                Preview not available for this file type.
              </p>
            )}
          </div>

          <hr />

          {/* Optional open in new tab */}
          {previewFile.url && (
            <div style={{ textAlign: "right" }}>
              <a
                href={previewFile.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: 600, textDecoration: "none" }}
              >
                Open in new tab
              </a>
            </div>
          )}
        </Box>
      </Modal>

      {/* Verification Modal */}
      <Dialog
        open={toggleModalOpenVerification}
        onClose={() => setToggleModalOpenVerification(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Are you sure?
          <IconButton
            aria-label="close"
            onClick={() => setToggleModalOpenVerification(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {toggleTarget && (
            <Typography>
              Do you want to{" "}
              <strong>
                {toggleTarget.currentValue ? "DISABLE" : "ENABLE"}
              </strong>{" "}
              <code>{toggleTarget.field}</code> for this Ryder?
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setToggleModalOpenVerification(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleToggleStatus}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
